import { ShaparakWizardStatusEnum } from "@payping/api";

/* eslint-disable no-shadow */

export type StepType = 1 | 2 | 3 | 4;

export enum FrontShaparakWizardStatusEnum {
  Default = 7,
}

type UserWizardStatusEnum = ShaparakWizardStatusEnum | FrontShaparakWizardStatusEnum;

export enum StatusIconEnum {
  success = 1,
  error = 2,
  userPending = 3,
  pending = 4,
  default = 5,
}

export interface WizardBoxType {
  description?: string;
  icon?: StatusIconEnum;
  isLastStep?: boolean;
  status?: UserWizardStatusEnum;
  step?: StepType;
  title?: string;
  reason?: string;
}

export interface StepsType {
  success: WizardBoxType;
  default: WizardBoxType;
  userPending?: WizardBoxType;
  adminPending?: WizardBoxType;
  adminConfirm?: WizardBoxType;
  shaparakPending?: WizardBoxType;
  shaparakReject?: WizardBoxType;
  adminReject?: WizardBoxType;
}
